// extracted by mini-css-extract-plugin
export default {"box":"BlockSpinner_box__PeeG+","show":"BlockSpinner_show__yrEvi"};